import { render, staticRenderFns } from "./ExpandableItemPTU.vue?vue&type=template&id=645df849&scoped=true"
import script from "./ExpandableItemPTU.vue?vue&type=script&lang=js"
export * from "./ExpandableItemPTU.vue?vue&type=script&lang=js"
import style0 from "./ExpandableItemPTU.vue?vue&type=style&index=0&id=645df849&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645df849",
  null
  
)

export default component.exports